(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_lp"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.querySelector('.lg-new-header-element-search-panel[data-open="true"]')) return;
      /* menu drawer open: never hide the header, or the close (X) button disappears */
      if (this.isDrawerOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    isDrawerOpen() {
      return !!this.querySelector('.lg-new-header-element-drawer[data-open="true"]');
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      /* a hide that was queued just before the menu opened must not run once it is open */
      if (this.isDrawerOpen()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeNavigationDropdowns();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

    closeNavigationDropdowns() {
      this.querySelectorAll('.lg-new-header-element-navigation-item--has-children').forEach((item) => {
        item.setAttribute('data-open', 'false');
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class LgNewHeaderController extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.bar = this.querySelector('.lg-new-header-element-bar');
      this.drawer = this.querySelector('.lg-new-header-element-drawer');
      this.toggle = this.querySelector('.lg-new-header-element-menu-toggle');
      this.navItems = Array.from(this.querySelectorAll('.lg-new-header-element-navigation-item--has-children'));
      this.panels = Array.from(this.querySelectorAll('.lg-new-header-element-drawer-panel'));
      this.lastPointerType = 'mouse';
      this.lastPanelTrigger = null;
      this.suppressFocusOpen = false;

      this.onDocumentPointerDown = (event) => {
        this.lastPointerType = event.pointerType || 'mouse';
        if (!this.contains(event.target)) {
          this.closeAllDropdowns();
          this.closeSearch(false);
        }
      };

      this.onKeyDown = (event) => {
        if (event.key !== 'Escape') return;

        if (this.isSearchOpen()) {
          this.closeSearch();
          return;
        }

        const openItem = this.navItems.find((item) => item.getAttribute('data-open') === 'true');
        if (openItem) {
          this.closeDropdown(openItem);
          this.suppressFocusOpen = true;
          openItem.querySelector('.lg-new-header-element-navigation-link').focus();
          this.suppressFocusOpen = false;
          return;
        }

        if (this.isDrawerOpen()) {
          const activePanel = this.panels.find((panel) => panel.getAttribute('data-state') === 'active');
          if (activePanel && activePanel.dataset.lgPanel !== 'main') {
            this.showPanel('main', true);
          } else {
            this.closeDrawer();
          }
        }
      };

      this.onBreakpointChange = (event) => {
        if (event.matches) {
          this.closeDrawer(false);
        } else {
          this.closeAllDropdowns();
        }
      };

      this.onPageShow = () => this.closeDrawer(false);

      document.addEventListener('pointerdown', this.onDocumentPointerDown);
      document.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('pageshow', this.onPageShow);
      this.desktopQuery.addEventListener('change', this.onBreakpointChange);

      this.bindDropdowns();
      this.bindDrawer();
      this.bindBagLabel();
      this.bindSearch();
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      document.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('pageshow', this.onPageShow);
      this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
      document.documentElement.classList.remove('lg-new-header-element-scroll-lock');
    }

    /* ---------- Desktop dropdowns ---------- */
    bindDropdowns() {
      this.navItems.forEach((item) => {
        const link = item.querySelector('.lg-new-header-element-navigation-link');

        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          this.openDropdown(item);
        });

        item.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch') return;
          this.closeDropdown(item);
        });

        item.addEventListener('focusin', (event) => {
          if (this.suppressFocusOpen) return;
          if (event.target.matches(':focus-visible')) this.openDropdown(item);
        });

        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.closeDropdown(item);
        });

        // On touch screens the first tap opens the dropdown, the second follows the link
        link.addEventListener('click', (event) => {
          if (this.lastPointerType === 'touch' && item.getAttribute('data-open') !== 'true') {
            event.preventDefault();
            this.openDropdown(item);
          }
        });
      });
    }

    openDropdown(item) {
      this.navItems.forEach((other) => {
        if (other !== item) this.closeDropdown(other);
      });
      item.setAttribute('data-open', 'true');
      item.querySelector('.lg-new-header-element-navigation-link').setAttribute('aria-expanded', 'true');
    }

    closeDropdown(item) {
      item.setAttribute('data-open', 'false');
      item.querySelector('.lg-new-header-element-navigation-link').setAttribute('aria-expanded', 'false');
    }

    closeAllDropdowns() {
      this.navItems.forEach((item) => this.closeDropdown(item));
    }

    /* ---------- Mobile drawer ---------- */
    bindDrawer() {
      if (!this.toggle || !this.drawer) return;

      this.toggle.addEventListener('click', () => {
        if (this.isDrawerOpen()) {
          this.closeDrawer();
        } else {
          this.openDrawer();
        }
      });

      this.drawer.querySelectorAll('[data-lg-target]').forEach((button) => {
        button.addEventListener('click', () => {
          this.lastPanelTrigger = button;
          this.showPanel(button.dataset.lgTarget, true);
        });
      });

      this.drawer.querySelectorAll('[data-lg-back]').forEach((button) => {
        button.addEventListener('click', () => this.showPanel('main', true));
      });
    }

    isDrawerOpen() {
      return !!this.drawer && this.drawer.getAttribute('data-open') === 'true';
    }

    /* Make sure the header bar (with the menu / close button) is on screen before the drawer opens.
       If the sticky header had slid away on scroll, bring it back with no animation, so the drawer
       starts right under it and the close button stays visible. */
    showHeaderForDrawer() {
      const sticky = this.closest('sticky-header');
      const header = (sticky && sticky.header) || document.querySelector('.section-header');
      if (!header || !header.classList.contains('shopify-section-header-hidden')) return;
      const previousTransition = header.style.transition;
      header.style.transition = 'none';
      header.classList.remove('shopify-section-header-hidden');
      header.classList.add('shopify-section-header-sticky');
      void header.offsetHeight; /* apply it now, before the drawer position is measured */
      header.style.transition = previousTransition;
    }

    openDrawer() {
      this.closeSearch(false);
      this.showHeaderForDrawer();
      const wrapper = this.closest('.lg-new-header-element-wrapper') || this.bar;
      const top = Math.max(0, Math.round(wrapper.getBoundingClientRect().bottom));
      this.drawer.style.setProperty('--lg-drawer-top', `${top}px`);
      this.drawer.setAttribute('data-open', 'true');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggle.setAttribute('aria-label', this.toggle.dataset.closeLabel);
      document.documentElement.classList.add('lg-new-header-element-scroll-lock');
    }

    closeDrawer(returnFocus = true) {
      if (!this.drawer || !this.toggle) return;
      const wasOpen = this.isDrawerOpen();
      this.drawer.setAttribute('data-open', 'false');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-label', this.toggle.dataset.openLabel);
      document.documentElement.classList.remove('lg-new-header-element-scroll-lock');
      this.showPanel('main');
      if (wasOpen && returnFocus) this.toggle.focus({ preventScroll: true });
    }

    showPanel(name, moveFocus = false) {
      this.panels.forEach((panel) => {
        const id = panel.dataset.lgPanel;
        let state = 'right';
        if (id === name) state = 'active';
        else if (id === 'main') state = 'left';
        panel.setAttribute('data-state', state);
      });

      if (!moveFocus) return;

      const target = this.panels.find((panel) => panel.dataset.lgPanel === name);
      requestAnimationFrame(() => {
        const focusTarget = name === 'main' && this.lastPanelTrigger
          ? this.lastPanelTrigger
          : target && target.querySelector('button, a[href]');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    }

    /* ---------- Search ---------- */
    bindSearch() {
      this.searchPanel = this.querySelector('.lg-new-header-element-search-panel');
      this.searchToggle = this.querySelector('.lg-new-header-element-search-button');
      if (!this.searchPanel || !this.searchToggle) return;

      this.searchForm = this.searchPanel.querySelector('form');
      this.searchInput = this.searchPanel.querySelector('.lg-new-header-element-search-input');
      this.searchResults = this.searchPanel.querySelector('.lg-new-header-element-search-results');
      this.searchTimer = null;
      this.searchRequest = null;

      this.searchToggle.addEventListener('click', () => {
        if (this.isSearchOpen()) {
          this.closeSearch();
        } else {
          this.openSearch();
        }
      });

      this.searchPanel.querySelector('[data-lg-search-close]').addEventListener('click', () => this.closeSearch());

      // Live product suggestions while typing (the form still submits to the full search page)
      this.searchInput.addEventListener('input', () => {
        window.clearTimeout(this.searchTimer);
        this.searchTimer = window.setTimeout(() => this.fetchSuggestions(), 250);
      });

      this.searchForm.addEventListener('submit', (event) => {
        if (!this.searchInput.value.trim()) {
          event.preventDefault();
          this.searchInput.focus();
        }
      });
    }

    isSearchOpen() {
      return !!this.searchPanel && this.searchPanel.getAttribute('data-open') === 'true';
    }

    openSearch() {
      if (!this.searchPanel) return;
      this.closeDrawer(false);
      this.closeAllDropdowns();
      this.searchPanel.setAttribute('data-open', 'true');
      this.searchToggle.setAttribute('aria-expanded', 'true');
      this.searchInput.focus({ preventScroll: true });
      requestAnimationFrame(() => {
        if (document.activeElement !== this.searchInput) this.searchInput.focus({ preventScroll: true });
      });
    }

    closeSearch(returnFocus = true) {
      if (!this.searchPanel || !this.isSearchOpen()) return;
      window.clearTimeout(this.searchTimer);
      if (this.searchRequest) {
        this.searchRequest.abort();
        this.searchRequest = null;
      }
      this.searchPanel.setAttribute('data-open', 'false');
      this.searchToggle.setAttribute('aria-expanded', 'false');
      this.renderSearchResults(null);
      if (returnFocus) this.searchToggle.focus({ preventScroll: true });
    }

    async fetchSuggestions() {
      const term = this.searchInput.value.trim();

      if (this.searchRequest) {
        this.searchRequest.abort();
        this.searchRequest = null;
      }

      if (term.length < 2) {
        this.renderSearchResults(null);
        return;
      }

      const controller = new AbortController();
      this.searchRequest = controller;
      const url = `${this.searchPanel.dataset.suggestUrl}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;

      try {
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        const data = await response.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        this.renderSearchResults(products, term);
      } catch (error) {
        if (error.name !== 'AbortError') this.renderSearchResults(null);
      }
    }

    formatSearchPrice(value) {
      const amount = parseFloat(value);
      if (Number.isNaN(amount)) return '';
      const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || undefined,
          currency ? { style: 'currency', currency } : { minimumFractionDigits: 2 }
        ).format(amount);
      } catch (error) {
        return amount.toFixed(2);
      }
    }

    // products = null hides the box; [] shows the "no results" message
    renderSearchResults(products, term) {
      const box = this.searchResults;
      if (!box) return;
      box.textContent = '';

      if (products === null) {
        box.hidden = true;
        return;
      }

      box.hidden = false;

      const allUrl = new URL(this.searchForm.getAttribute('action'), window.location.origin);
      allUrl.searchParams.set('q', term);
      allUrl.searchParams.set('options[prefix]', 'last');

      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'lg-new-header-element-search-empty';
        empty.textContent = `${box.dataset.emptyText} "${term}"`;
        box.appendChild(empty);
        return;
      }

      const list = document.createElement('ul');
      list.className = 'lg-new-header-element-search-results-list';

      products.forEach((product) => {
        const item = document.createElement('li');
        item.className = 'lg-new-header-element-search-result';

        const link = document.createElement('a');
        link.className = 'lg-new-header-element-search-result-link';
        link.href = product.url;

        const imageUrl = (product.featured_image && product.featured_image.url) || product.image;
        if (imageUrl) {
          const img = document.createElement('img');
          img.className = 'lg-new-header-element-search-result-image';
          img.src = `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}width=112`;
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          link.appendChild(img);
        }

        const info = document.createElement('span');
        info.className = 'lg-new-header-element-search-result-info';

        const title = document.createElement('span');
        title.className = 'lg-new-header-element-search-result-title';
        title.textContent = product.title;
        info.appendChild(title);

        const price = this.formatSearchPrice(product.price);
        if (price) {
          const priceEl = document.createElement('span');
          priceEl.className = 'lg-new-header-element-search-result-price';
          priceEl.textContent = price;
          info.appendChild(priceEl);
        }

        link.appendChild(info);
        item.appendChild(link);
        list.appendChild(item);
      });

      box.appendChild(list);

      const all = document.createElement('a');
      all.className = 'lg-new-header-element-search-all';
      all.href = allUrl.pathname + allUrl.search;
      all.textContent = box.dataset.allText;
      box.appendChild(all);
    }

    /* ---------- "Your Bag" label ---------- */
    // Dawn replaces the inner HTML of #cart-icon-bubble after add to cart, so the text label
    // lives next to it and simply forwards its click to the icon link.
    bindBagLabel() {
      const label = this.querySelector('.lg-new-header-element-bag-label');
      const iconLink = this.querySelector('.lg-new-header-element-bag-link');
      if (!label || !iconLink) return;

      label.addEventListener('click', (event) => {
        event.preventDefault();
        iconLink.click();
      });
    }
  }

  customElements.define('lg-new-header-controller', LgNewHeaderController);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-blog-page"] && !Shopify.designMode) return;
  try {
    
  let blogTabs = document.querySelectorAll('.single-blog-post-tabs a');
  let cowFatPosts = document.querySelector('.cowFat-posts-wrapper');

  blogTabs.forEach(function (blogTab) {
    blogTab.addEventListener('click', function (event) {
      event.preventDefault();
      let tabName = this.getAttribute('data-name');

      cowFatPosts.classList.remove('grid-view', 'list-view');

      blogTabs.forEach(function (tab) {
        tab.parentElement.classList.remove('active');
      });

      this.parentElement.classList.add('active');

      if (tabName === 'grid') {
        cowFatPosts.classList.add('grid-view');
      } else {
        cowFatPosts.classList.add('list-view');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-blog-single-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let showPostCta = document.querySelector('.share-post-cta');
    let fixedBox = document.querySelector('.sharable-post-box');

    showPostCta.addEventListener('click', function (e) {
      e.stopPropagation();
      fixedBox.classList.toggle('showPostBox');
    });

    document.body.addEventListener('click', function (event) {
      if (!fixedBox.contains(event.target)) {
        fixedBox.classList.remove('showPostBox');
      }
    });
  });
  $('p')
    .filter(function () {
      console.log(this);
      return this.innerHTML == '&nbsp;';
    })
    .remove();

  } catch(e) { console.error(e); }
})();
})();
